import styled from 'styled-components';

export const StyledScreenFrame = styled.div`
  display: grid;
  // padding: ${({ theme }) => theme.frameOffset};
  background: ${({ theme, $color }) => $color != null ? $color : theme.background};
  grid-column: ${({theme, $gridColumn}) => $gridColumn};
  grid-row: ${({theme, $gridRow}) => $gridRow};
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);

  .scroller {
    display: grid;
    position: relative;
    height: 100%;
    width: 100%;
    border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  }

  .screen-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
  }

  .screen-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .screen-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .screen-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .screen-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: 12px 12px;
  }
`;
